import { Community } from 'redux/types/account';

export const handleRedirect = (community: Community) => {
  let env: 'local' | 'staging' | 'production' = 'local';

  console.log('community.isNewFrontendEnabled', community?.isNewFrontendEnabled);

  if (!community?.isNewFrontendEnabled) {
    return;
  }

  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'staging' && !window.origin.includes('localhost')) {
    env = 'staging';
  }

  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'production') {
    env = 'production';
  }

  const path = window.location.pathname;
  console.log('Current path:', path);
  console.log(
    'path includes admin-panel',
    path.includes('admin-panel'),
    'path does not include events-settings',
    !path.includes('events-settings'),
  );
  console.log('window includes app.babele.co', window.origin.includes('app.babele.co'));

  if ((path.includes('admin-panel') || path.includes('application')) && !path.includes('events-settings')) {
    console.log('Redirecting to new frontend admin panel', env, path);
    if (env === 'local') {
      window.location.href = `http://localhost:3001${path}`;
    }

    if (env === 'staging') {
      window.location.href = `${getStagingUrl()}${path}`;
    }

    // We must be careful to only redirect to the new frontend if we can redirect to the same main domain
    // If we are on the main babele.com domain, we redirect to the new frontend on admin.babele.co
    // If we are on a custom domain, we redirect if there's also a custom DNS configured for the new frontend
    // If not, try to redirect to the same main domain, but with app-new prefix
    if (env === 'production') {
      if (community?.customDns?.host) {
        if (window.origin.includes('app.babele.co')) {
          window.location.href = `https://app-new.babele.co${path}`;
        } else {
          if (community?.customDns?.newFrontendHost) {
            window.location.href = `https://${community.customDns.newFrontendHost}${path}`;
          } else {
            const newHost = community.customDns.host.replace('app.', 'app-new.');
            console.log(`No custom DNS configured for the new frontend, trying to redirect to ${newHost}`);
            window.location.href = `https://${newHost}${path}`;
          }
        }
      } else {
        console.log('no custom DNS configured for the new frontend');
        if (window.origin.includes('app-ms.babele.co')) {
          console.log('Redirecting to app-new-ms.babele.co from app-ms.babele.co');
          window.location.href = `https://app-new-ms.babele.co${path}`;
        }

        if (window.origin.includes('app.babele.co')) {
          console.log('Redirecting to app-new.babele.co');
          window.location.href = `https://app-new.babele.co${path}`;
        } else {
          console.log("We're not on babele.co domain, trying to redirect to app-new.currentdomain.com");
          const currentHost = window.location.host;
          const newHost = currentHost.replace('app.', 'app-new.');
          window.location.href = `https://${newHost}${path}`;
        }
      }
    }
  }
};

export const getStagingUrl = () => {
  if (window.location.href.includes('app-old-preview-1.babele.co')) {
    return 'https://app-preview-1.babele.co';
  }

  if (window.location.href.includes('app-old-preview-2.babele.co')) {
    return 'https://app-preview-2.babele.co';
  }

  if (window.location.href.includes('app-old-preview-3.babele.co')) {
    return 'https://app-preview-3.babele.co';
  }

  return 'https://app-new-stag.babele.co';
};

export const getNewFrontendHost = (community: Community) => {
  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'production') {
    if (community?.customDns?.newFrontendHost) {
      return `https://${community.customDns.newFrontendHost}`;
    }

    if (window.origin.includes('app-ms.babele.co')) {
      return 'https://app-new-ms.babele.co';
    }

    return 'https://app-new.babele.co';
  }

  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'staging') {
    return getStagingUrl();
  }

  return 'http://localhost:3001';
};
